import { Button, Grid } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import FeedbackIcon from "@material-ui/icons/Feedback";
import React from "react";
import { sanitizeDocumentName } from "../../../../../../../utils/formatters";
import PanelBase from "./base";

const DocumentButton = (props) => (
  <Button size="large" variant="outlined" fullWidth {...props} />
);

const PanelUI = ({ list, title }) => (
  <Grid item xs={12} md={6}>
    <div className="center-text pt-0">{title.toUpperCase()}</div>

    {list?.length > 0 ? (
      list.map(({ id, attributes: { title, url } }) => (
        <DocumentButton
          key={id}
          startIcon={<DescriptionIcon />}
          onClick={() => window.open(url)}
        >
          {sanitizeDocumentName(title)}
        </DocumentButton>
      ))
    ) : (
      <DocumentButton startIcon={<FeedbackIcon />} disabled>
        Não possuímos documentos
      </DocumentButton>
    )}
  </Grid>
);

export default ({ docsPrecatorio, docsProcesso, ...restProps }) => {
  return (
    <PanelBase {...restProps}>
      <Grid spacing={3} container>
        <PanelUI list={docsPrecatorio} title="Precatório" />
        <PanelUI list={docsProcesso} title="Processo originário" />
      </Grid>
    </PanelBase>
  );
};
